import { render, staticRenderFns } from "./NewsRelease.vue?vue&type=template&id=29e96ef4&scoped=true&"
import script from "./NewsRelease.vue?vue&type=script&lang=ts&"
export * from "./NewsRelease.vue?vue&type=script&lang=ts&"
import style0 from "./NewsRelease.vue?vue&type=style&index=0&id=29e96ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e96ef4",
  null
  
)

export default component.exports